function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.2724 4.4384c.4474-.1087.9135.1087 1.1.5254.0559.1449.0932.2898.0932.4529-.0187.4529-.056.9239-.0932 1.3768-.0373.7065-.0933 1.4311-.1305 2.1377-.0187.2355-.0187.2536-.0187.489-.0186.3805-.317.6704-.7084.6704-.3915 0-.6898-.2718-.7085-.6522-.0559-1.105-.1305-2.029-.1864-3.134a231.435 231.435 0 0 1-.056-.8877c-.0186-.453.261-.8515.7085-.9783m.2424 8.3333c-.522 0-.9508-.4166-.9508-.9239 0-.5072.4288-.9239.9508-.9239s.9508.4167.9321.942c.0187.4892-.4288.9058-.9321.9058M2.549 15h11.8943c1.9575 0 3.188-2.0833 2.2185-3.7138L10.696 1.25c-.9694-1.6667-3.4303-1.6667-4.3997 0L.3305 11.2862C-.6203 12.9348.5915 15 2.549 15",
  fill: "#ADBBCD",
  fillRule: "evenodd"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 17,
    height: 15
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/BlueWarning.8261ed0d.svg";
export { SvgComponent as ReactComponent };